import angular from 'angular';
import '../tab';

import { TabsComponent } from './tabs.component';

angular
  .module('core.components.tabs', ['core.components.tab'])
  .component('easyshipTabs', TabsComponent);
